import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
  Input,
  Row,
  ListGroupItem,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Button,
  ButtonGroup,
  Collapse,
  Alert,
  Label,
  DropdownToggle,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  Card,
  Badge,
  CardBody
} from "reactstrap";
import { units } from "../../../../../common/units";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../components/UI/Buttons/DropDownFacade";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import ArchiveContainer from "../../../../../file/containers/ArchiveContainer";
import {
  deepClone,
  setValueToNestedObject
} from "../../../../../helpers/objectHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { templateHelper } from "../../helpers/templateHelper";
import BoxShadowSettings from "../../../../components/editor/BoxShadowSettings/BoxShadowSettings";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
const SliderWithTooltip = createSliderWithTooltip(Slider);

class HeaderSettings extends React.Component {
  state = { isMediaVaultOpen: false }
  handleUpdate = template => {
    const { dispatch } = this.props;
    dispatch(templateActions.softUpdate(template));
  };
  handleChange = (color, e, path, fallbackUnit = null) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let value = templateHelper.getValueFromInput(e, color);
    let unit = templateHelper.getUnit(templateCopy, names);
    if (parseInt(value) && unit.length < 4) {
      value += unit;
    }
    templateCopy.content = deepClone(
      setValueToNestedObject(names, value, templateCopy.content)
    );
    this.handleUpdate(templateCopy);
  };
  handleUnitChange = (unit, path) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    const value = templateHelper.getValueWithoutUnit(templateCopy, names);
    templateCopy.content = setValueToNestedObject(
      names,
      value + unit,
      templateCopy.content
    );

    if (unit === "auto") {
      templateCopy.content[names[0]][names[1]] = unit;
    }
    this.handleUpdate(templateCopy);
  };
  changeBackgroundImage = url => {
    const { template } = this.props;
    const templateCopy = deepClone(template);
    templateCopy.content.header.background = `url('${url}')  no-repeat center center / cover`;
    templateCopy.content.header.backgroundSize = `cover`;
    templateCopy.content.header.backgroundUrl = url;
    this.handleUpdate(templateCopy);
  };
  setBackgroundImage = url => {
    const { template } = this.props;
    const templateCopy = deepClone(template);
    templateCopy.content.header.background = `url('${url}')  no-repeat center center / cover`;
    templateCopy.content.header.backgroundSize = `cover`;
    templateCopy.content.header.backgroundUrl = url;
    /*   document.body.style.background = templateCopy.content.header.background; */
    this.handleUpdate(templateCopy);
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  render() {
    const { template, device } = this.props;
    if (template === undefined) return null;
    return (
      <div style={{ paddingTop: "10px" }}>
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade
              color={template && template.content.header.background}
              onChange={(color, e) =>
                this.handleChange(color, e, "header.background")
              }
              path="header.background"
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundImage" />
            </Label>
          </Col>
        </Row>
        <Row>
          <Col className="list-setting-item-title">
            {template && template.content.header.backgroundUrl && (
              <img
                style={{ cursor: "pointer", width: "120px", marginTop: "5px" }}
                onClick={() =>
                  this.setAttribute(
                    `url('${template.content.header.backgroundUrl}')  no-repeat center center / cover`,
                    "header.background"
                  )
                }
                alt=""
                src={template.content.header.backgroundUrl}
              />
            )}
          </Col>
        </Row>
        <UrlMultiInput margin={false} onChange={this.setBackgroundImage} setImage={this.setBackgroundImage} path={'header.backgroundUrl'} url={template.content.header.backgroundUrl} />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath(
              "header",
              "marginBottom",
              device
            )
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath(
              "header",
              "marginBottom",
              device
            )
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "header",
                "marginBottom",
                device
              )
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "header",
            "marginBottom",
            device
          )}
          label="MarginBottom"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath("header", "marginTop", device)
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("header", "marginTop", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "header",
                "marginTop",
                device
              )
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "header",
            "marginTop",
            device
          )}
          label="MarginTop"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath("header", "height", device)
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("header", "height", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath("header", "height", device)
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "header",
            "height",
            device
          )}
          label="HeaderHeight"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath("header", "width", device)
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("header", "width", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath("header", "width", device)
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "header",
            "width",
            device
          )}
          label="HeaderWidth"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath("header", "innerWidth", device)
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("header", "innerWidth", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath("header", "innerWidth", device)
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "header",
            "innerWidth",
            device
          )}
          label="InnerWidth"
        />

        <BoxShadowSettings
          boxShadowEnabled={
            (template.content.header.boxShadow !== 'unset'
              && template.content.header.boxShadow !== 'none')}
          value={template.content.header.boxShadow}
          path={'header.boxShadow'}
          onChange={this.handleChange} />

      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template.template,
    device: state.template.previewDevice
  };
}
export default connect(mapStateToProps)(HeaderSettings);
